import React, {useRef, useEffect, useMemo, useState} from 'react';
import {useMediaQuery, useTheme} from "@mui/material";
let sdnn = 0
let rmssd = 0
let pnn20 = 0
let pnn50 = 0

const CanvasGrid = ({ points, setPulsUser=(value)=>{}, variant='default' }) => {
    const canvasRef = useRef(null);
    const requestRef = useRef(null);
    const previousPointRef = useRef(0);
    const pointIdRef = useRef(0);
    const isFirstR =  useRef(false);
    const isFirstRX =  useRef(0);
    const pointPhotoIdRef = useRef({x:0, y:0, isRPeaks:false});
    const startRef = useRef();
    const [animationPoints, setAnimationPoints] = useState([]);
    const [pulsSet, setPulsSet] = useState([]);
    const containerRef = useRef(null);
    let xMoveDif = useRef(0);
    let xLineDif = useRef(0);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isUserReport = variant === 'userReport';
    const pixelsPerSecond = useRef(250);

    const lastTime = useRef(0);
    const difTime = useRef(0);
    const timeStep = useRef(1);
    const signalRanges = useMemo(() => {
        const range = (key, ignoreZero = false) => {
            let min = Number.POSITIVE_INFINITY;
            let max = Number.NEGATIVE_INFINITY;
            animationPoints.forEach((point) => {
                const value = Number(point?.[key]);
                if (!Number.isFinite(value) || (ignoreZero && value === 0)) return;
                min = Math.min(min, value);
                max = Math.max(max, value);
            });
            if (!Number.isFinite(min) || !Number.isFinite(max)) return {min: 0, max: 1};
            if (min === max) return {min: min - 1, max: max + 1};
            return {min, max};
        };
        return {
            ecg: range('y'),
            ppg: range('y1', true),
        };
    }, [animationPoints]);

    const getSignalY = (value, range, top, bottom) => {
        const numeric = Number(value);
        if (!Number.isFinite(numeric)) return bottom;
        const normalized = (numeric - range.min) / (range.max - range.min);
        return bottom - normalized * (bottom - top);
    };

    const getAxes = (height) => ({
        ecg: Math.floor(height / 2),
        ppg: height - 26,
    });
    const drawUserReportTimeTick = (ctx, x, seconds, height) => {
        const axes = getAxes(height);
        ctx.strokeStyle = '#1498a3';
        ctx.lineWidth = 1;
        ctx.fillStyle = '#657086';
        ctx.font = '10px Arial';
        ctx.textAlign = 'left';
        [axes.ecg, axes.ppg].forEach((axisY) => {
            ctx.beginPath();
            ctx.moveTo(x + 0.5, axisY);
            ctx.lineTo(x + 0.5, axisY + 5);
            ctx.stroke();
            ctx.fillText(`${seconds}s`, x + 2, axisY + 15);
        });
    };

    let resizeWindow = () => {
        drawGrid()
        drawTimeScale()
        console.log(window.innerHeight,'window.innerHeight')
    };

    useEffect(() => {
        resizeWindow();
        window.addEventListener("resize", resizeWindow);
        return () => window.removeEventListener("resize", resizeWindow);
    }, []);

    const drawGrid = () => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        canvas.width = containerRef.current.scrollWidth;
        const width = canvas.width;
        canvas.height = isUserReport
            ? Math.max(
                1,
                containerRef.current.clientHeight ||
                    window.innerHeight - (isMobile ? 138 : 84),
            )
            : window.innerHeight - (isMobile?138:84);
        const height = canvas.height;

        // Очистка canvas
        ctx.clearRect(0, 0, width, height);
        ctx.fillStyle = isUserReport ? '#020316' : '#0c0e12'
        ctx.fillRect(0, 0, width, height);
        if (isUserReport) {
            const axes = getAxes(height);
            ctx.strokeStyle = '#1498a3';
            ctx.lineWidth = 1;
            [axes.ecg, axes.ppg].forEach((axisY) => {
                ctx.beginPath();
                ctx.moveTo(0, axisY + 0.5);
                ctx.lineTo(width, axisY + 0.5);
                ctx.stroke();
            });

            ctx.font = '11px Arial';
            ctx.fillStyle = '#e1262f';
            ctx.fillText('ECG', 10, 20);
            ctx.fillStyle = '#12a8b3';
            ctx.fillText('PPG', 10, axes.ecg + 45);
            return;
        }
        //#13161B
        // Настройки для сетки

        ctx.lineWidth = 0.2;
        ctx.fillStyle = '#13161B';

        // Рисуем точки с шагом 10 пикселей
        for (let x = 15; x < width; x += 15) {
            for (let y = 15; y < height; y += 15) {
                ctx.fillRect(x, y, 2, 2); // Рисуем точку размером 1x1 пиксель
            }
        }
        ctx.strokeStyle = '#13161B';
        ctx.lineWidth = 10;
        ctx.beginPath();
        ctx.moveTo(0, height/2);

        ctx.lineTo(width, height/2);
        ctx.stroke();
        ctx.strokeStyle = '#ea0606';
        // Отрисовка сетки с шагом 1 мм (предположим, что 1 мм = 4 пикселя)
        /*for (let x = 0; x < width; x += 4) {
            ctx.beginPath();
            ctx.moveTo(x, 0);
            ctx.lineTo(x, height);
            ctx.stroke();
        }*/

        /*for (let y = 0; y < height; y += 4) {
            ctx.beginPath();
            ctx.moveTo(0, y);
            ctx.lineTo(width, y);
            ctx.stroke();
        }*/

        // Отрисовка сетки с шагом 10 мм (предположим, что 10 мм = 40 пикселей)
        /*ctx.strokeStyle = '#db2c2c';
        ctx.lineWidth = 0.3;

        for (let x = 0; x < width; x += 40) {
            ctx.beginPath();
            ctx.moveTo(x, 0);
            ctx.lineTo(x, height);
            ctx.stroke();
        }

        for (let y = 0; y < height; y += 40) {
            ctx.beginPath();
            ctx.moveTo(0, y);
            ctx.lineTo(width, y);
            ctx.stroke();
        }
        */

        ctx.strokeStyle = '#fff';
        ctx.lineWidth = 1;

        for (let x = 40; x < width; x += 80) {
            ctx.beginPath();
            ctx.moveTo(x, height);
            ctx.lineTo(x, height - 7);
            ctx.stroke();
        }
        for (let x = 0; x < width; x += 80) {
            ctx.beginPath();
            ctx.moveTo(x, height);
            ctx.lineTo(x, height - 12);
            ctx.stroke();
        }

        ctx.beginPath();
        ctx.moveTo(0, height-1);
        ctx.lineTo(width, height-1);
        ctx.stroke();
    };
    const drawTimeScale = (added = false) => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        const width = canvas.width;
        const height = canvas.height;
        if (isUserReport) {
            drawUserReportTimeTick(
                ctx,
                0,
                Math.floor(pointIdRef.current / pixelsPerSecond.current),
                height,
            );
            return;
        }
        //console.log(added)
        ctx.fillStyle = '#fff';
        ctx.font = '12px Arial';

        // Отрисовка временной шкалы
        if(!added) {
            lastTime.current = 0
            difTime.current = 0
        }
        for (var t = lastTime.current; t <= lastTime.current + (width / pixelsPerSecond.current)-difTime.current; t += timeStep.current) {
            const x = (t - lastTime.current) * pixelsPerSecond.current
            //ctx.fillText(t.toFixed(1) + 's', x+difTime.current* pixelsPerSecond.current, height - 15)

        }
        if(t>(width / pixelsPerSecond.current)) {
            difTime.current = difTime.current+((t - lastTime.current) - (width / pixelsPerSecond.current))
        }
        lastTime.current = t

    }

    useEffect(() => {

        drawGrid();
        drawTimeScale()

    }, []);
    const animate =(timestamp)=>{
        const canvas = canvasRef.current;
        const height = canvas.height;
        const ctx = canvas.getContext('2d');
        ctx.strokeStyle = isUserReport ? '#e1262f' : 'blue';
        ctx.lineWidth = isUserReport ? 1.25 : 3;


        if (!startRef.current) {
            startRef.current = timestamp;
        }
        if(previousPointRef.current && timestamp-startRef.current>100){
            if(previousPointRef.current<timestamp){
                let i =1

                while(i<5) {

                    if (!animationPoints[pointIdRef.current]) {
                        return () => cancelAnimationFrame(requestRef.current);
                    }
                    let xMove = animationPoints[Math.max(pointIdRef.current - 1, 0)].x
                    let xLine = animationPoints[pointIdRef.current].x
                    const previousPoint = animationPoints[Math.max(pointIdRef.current - 1, 0)];
                    const currentPoint = animationPoints[pointIdRef.current];
                    const axes = getAxes(height);
                    const previousEcgY = isUserReport
                        ? getSignalY(previousPoint.y, signalRanges.ecg, 34, axes.ecg - 25)
                        : canvas.height - previousPoint.y;
                    const currentEcgY = isUserReport
                        ? getSignalY(currentPoint.y, signalRanges.ecg, 34, axes.ecg - 25)
                        : canvas.height - currentPoint.y;

                    if(animationPoints[Math.max(pointIdRef.current - 1, 0)].x!==0 && animationPoints[Math.max(pointIdRef.current - 1, 0)].x % containerRef.current.scrollWidth ===0) {
                        //ctx.clearRect(0, 0, canvas.width, canvas.height);
                        drawGrid();
                        drawTimeScale(true)

                        if (!isUserReport) {
                            ctx.fillStyle = "#ffffff";
                            const textX = 20;
                            const textY = canvas.height - canvas.height / 2 + 50;
                            const textWidth = ctx.measureText("SDNN: " + 1).width;
                            const textHeight = 20;

                            ctx.clearRect(textX, textY - textHeight, textWidth+100, textHeight*4);
                            ctx.fillText("SDNN:", 20, canvas.height - canvas.height/2+50)
                            ctx.fillText("RMSSD:", 20, canvas.height - canvas.height/2+70)
                            ctx.fillText("PNN20:", 20, canvas.height - canvas.height/2+90)
                            ctx.fillText("PNN50:", 20, canvas.height - canvas.height/2+110)
                            ctx.fillText(animationPoints[pointIdRef.current].marker, xMove - Number(xMoveDif.current), canvas.height - animationPoints[pointIdRef.current].y)

                            ctx.fillStyle = "#17B26A";
                            ctx.fillText(sdnn, 20+textWidth, canvas.height - canvas.height/2+50)
                            ctx.fillText(rmssd, 20+textWidth, canvas.height - canvas.height/2+70)
                            ctx.fillText(pnn20, 20+textWidth, canvas.height - canvas.height/2+90)
                            ctx.fillText(pnn50, 20+textWidth, canvas.height - canvas.height/2+110)
                        }

                        isFirstR.current = false
                        xMoveDif.current = (animationPoints[Math.max(pointIdRef.current - 1, 0)].x / containerRef.current.scrollWidth) * containerRef.current.scrollWidth
                        xLineDif.current = (animationPoints[Math.max(pointIdRef.current - 1, 0)].x / containerRef.current.scrollWidth) * containerRef.current.scrollWidth
                    }
                        ctx.strokeStyle = isUserReport ? '#e1262f' : 'blue';
                        ctx.beginPath();
                        ctx.moveTo(xMove - Number(xMoveDif.current), previousEcgY);
                        ctx.lineTo(xLine - Number(xLineDif.current), currentEcgY);
                        if(animationPoints[pointIdRef.current].marker && animationPoints[pointIdRef.current].marker==='R'){
                            if(!isFirstR.current) {
                                isFirstR.current = true
                                isFirstRX.current = xMove - Number(xMoveDif.current)
                            }else{

                                //setPulsUser((60/(((xMove - Number(xMoveDif.current))-isFirstRX.current)/250 )).toFixed(0))
                                const puls = Number((60/(((xMove - Number(xMoveDif.current))-isFirstRX.current)/250 )).toFixed(0))
                                setPulsSet(prev => {
                                    const array = [...prev, puls]
                                    if(array.length>4){
                                        const lastFive = array.slice(-5); // Получаем последние 5 элементов
                                        const average = lastFive.reduce((sum, val) => {
                                            return sum + val
                                        }, 0) / 5;
                                        setPulsUser(average.toFixed(0))
                                    }
                                    return array; // Создаем новый массив с добавленным элементом
                                });
                                isFirstRX.current = xMove - Number(xMoveDif.current)

                            }
                            ctx.fillStyle = "#ffffff";
                        }
                        if(!isUserReport && animationPoints[pointIdRef.current].marker) {
                            ctx.fillStyle = "#ffffff";
                            const textX = 20;
                            const textY = canvas.height - canvas.height / 2 + 50;
                            const textWidth = ctx.measureText("SDNN: " + 1).width;

                            const textHeight = 20;

                            ctx.clearRect(textX, textY - textHeight, textWidth+100, textHeight*4);
                            ctx.fillText("SDNN:", 20, canvas.height - canvas.height/2+50)
                            ctx.fillText("RMSSD:", 20, canvas.height - canvas.height/2+70)
                            ctx.fillText("PNN20:", 20, canvas.height - canvas.height/2+90)
                            ctx.fillText("PNN50:", 20, canvas.height - canvas.height/2+110)

                            //ctx.fillText(animationPoints[pointIdRef.current].marker, xMove - Number(xMoveDif.current), canvas.height - animationPoints[pointIdRef.current].y)

                            ctx.fillStyle = "#17B26A";

                            ctx.fillText(animationPoints[pointIdRef.current].sdnn.toFixed(2), 20+textWidth, canvas.height - canvas.height/2+50)
                            ctx.fillText(animationPoints[pointIdRef.current].rmssd.toFixed(2), 20+textWidth, canvas.height - canvas.height/2+70)
                            ctx.fillText(animationPoints[pointIdRef.current].pnn20.toFixed(2), 20+textWidth, canvas.height - canvas.height/2+90)
                            ctx.fillText(animationPoints[pointIdRef.current].pnn50.toFixed(2), 20+textWidth, canvas.height - canvas.height/2+110)
                            sdnn = animationPoints[pointIdRef.current].sdnn.toFixed(2)
                            rmssd = animationPoints[pointIdRef.current].rmssd.toFixed(2)
                            pnn20 = animationPoints[pointIdRef.current].pnn20.toFixed(2)
                            pnn50 = animationPoints[pointIdRef.current].pnn50.toFixed(2)
                        }
                        ctx.stroke();
                        if(pointIdRef.current%250===0) {
                            if (isUserReport) {
                                drawUserReportTimeTick(
                                    ctx,
                                    pointIdRef.current - Number(xMoveDif.current),
                                    pointIdRef.current / pixelsPerSecond.current,
                                    height,
                                );
                            } else {
                                ctx.fillStyle = "#ffffff";
                                ctx.fillText(pointIdRef.current / 250 + 's', pointIdRef.current - Number(xMoveDif.current) , height - 15)
                                ctx.fillText(pointIdRef.current / 250 +1 + 's', pointIdRef.current - Number(xMoveDif.current) +250, height - 15)
                            }
                        }
                        ctx.strokeStyle = isUserReport ? '#12a8b3' : 'red';
                        ctx.beginPath();
                        if(xLine ===0){
                            //ctx.moveTo(xLine - Number(xLineDif.current), canvas.height - animationPoints[pointIdRef.current].y1);
                            pointPhotoIdRef.current = {x:xLine, y:animationPoints[pointIdRef.current].y1, isRPeaks:animationPoints[pointIdRef.current].isRPeaks}
                        }
                        if (animationPoints[pointIdRef.current].y1 && xLine!==0) {
                            if (isUserReport) {
                                const ppgTop = axes.ecg + 75;
                                const ppgBottom = axes.ppg - 25;
                                if (pointPhotoIdRef.current.y) {
                                    ctx.moveTo(
                                        pointPhotoIdRef.current.x - Number(xMoveDif.current),
                                        getSignalY(
                                            pointPhotoIdRef.current.y,
                                            signalRanges.ppg,
                                            ppgTop,
                                            ppgBottom,
                                        ),
                                    );
                                    ctx.lineTo(
                                        xLine - Number(xLineDif.current),
                                        getSignalY(currentPoint.y1, signalRanges.ppg, ppgTop, ppgBottom),
                                    );
                                }
                            } else {
                                ctx.moveTo(pointPhotoIdRef.current.x - Number(xMoveDif.current), canvas.height - pointPhotoIdRef.current.y);
                                ctx.lineTo(xLine - Number(xLineDif.current), canvas.height - animationPoints[pointIdRef.current].y1);
                            }
                            pointPhotoIdRef.current = {x:xLine, y:animationPoints[pointIdRef.current].y1, isRPeaks:animationPoints[pointIdRef.current].isRPeaks}

                        }
                        //ctx.fillText(t.toFixed(1) + 's', x+difTime.current* pixelsPerSecond.current, height - 15)
                        ctx.stroke();
                    pointIdRef.current = pointIdRef.current+1
                    i++

                }
                /*if (containerRef.current && pointIdRef.current>1300) {
                    console.log(animationPoints[pointIdRef.current].x)
                    containerRef.current.scrollLeft = animationPoints[pointIdRef.current].x-1300;
                }*/
                if (containerRef.current && pointIdRef.current>1300) {

                }
            }
        }
        previousPointRef.current = timestamp

        requestRef.current = requestAnimationFrame(animate);

    }

    useEffect(()=>{
        startRef.current = 0
        requestRef.current = requestAnimationFrame(animate);
        return () => cancelAnimationFrame(requestRef.current);
    },[animationPoints])
    useEffect(() => {
        if(points.length===0){
            pointIdRef.current = 0
            drawGrid();
            drawTimeScale()
        }
        setAnimationPoints(points);
        console.log(points)
    }, [points]);


    return (
        <div
            ref={containerRef}

            style={{backgroundColor: isUserReport ? '#020316' : '#0c0e12'}}

        >
            <canvas ref={canvasRef} height={600} />
        </div>
    )

};

export default CanvasGrid;
